import { Injectable } from '@angular/core';

/**
 * Remembers where to send the user when the card gateway redirects back.
 *
 * Checkout leaves the app entirely, so in-memory state is lost by the time the
 * gateway returns. The gateway's redirect target is configured server-side and
 * points at a path this app doesn't define, so the router's wildcard sends the
 * user to the landing page instead of the cart — this bridges that gap.
 */
@Injectable({ providedIn: 'root' })
export class PaymentReturnService {
  private static readonly KEY = 'tsp-payment-return-path';

  /** Called just before handing off to the gateway. */
  remember(path: string): void {
    sessionStorage.setItem(PaymentReturnService.KEY, path);
  }

  /** Read the stored path and clear it, so it only redirects once. */
  consume(): string | undefined {
    const path = sessionStorage.getItem(PaymentReturnService.KEY);
    sessionStorage.removeItem(PaymentReturnService.KEY);
    return path ?? undefined;
  }
}
